// extracted by mini-css-extract-plugin
export default {"root":"GlobalLoader_root__7nkJ8","bar":"GlobalLoader_bar__6+VaS","indeterminate":"GlobalLoader_indeterminate__qKO4h","indeterminate-short":"GlobalLoader_indeterminate-short__LYv7o"};